import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent, SelectOptions } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { EventCreate } from '@app/models/event.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-event-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class EventFormComponent {
  initialValue = input<EventCreate>();
  formChange = output<EventCreate>();
  formValid = output<boolean>();

  eventForm = new FormGroup<AutoForm<EventCreate>>({
    name: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    id: new FormControl<number>(0, { validators: [Validators.required], nonNullable: true}),
    description: new FormControl<string>('', { nonNullable: true}),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.eventForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.eventForm.valid);
    this.formChange.emit(<EventCreate>this.eventForm.value);
  }
}